import { EDeliveryAddressStatus } from "./EDeliveryAddressStatus";

export interface IEDeliveryAddress {
  id: number;
  creationDate: string;
  label: string;

  address: string;
  closingDate?: string;
  isMain: boolean;
  isExposed: boolean;
  status: EDeliveryAddressStatus;
  role: number;

  validFrom?: string;
  validTo?: string;
  expireSoon: boolean;

  isCitizen: boolean;
  isEntrepreneur: boolean;
  isTrustedRole: boolean;

  serviceProvider?: string;
  isOurServiceProvider?: string;

  profileId?: string;
}

export interface IEDeliveryAddressPrivileges {
  AddressId: number;
  Address: string;

  Admin: IEDeliveryAddressUserPrivileges[];
  Read: IEDeliveryAddressUserPrivileges[];
  Write: IEDeliveryAddressUserPrivileges[];
}

export interface IEDeliveryAddressUserPrivileges {
  AddressId: number;
  UserId: string;
  Label: string;
  Privilege: EEDeliveryAddressPrivilege;
  Fixed?: boolean;
}

export enum EEDeliveryAddressPrivilege {
  None = 0,
  Read = 1,
  Write = 2,
  Admin = 4,
}
